import { StatisticsLayout } from "@/shared/layouts";
import CheckPage from "@/refund/pages/check";
import InitPage from "@/refund/pages/init";
import ContractPage from "@/refund/pages/contract";
import WalletPage from "@/refund/pages/wallet";
import ReceiptPage from "@/refund/pages/receipt";

import refund from "./constants";

const routes = [
  {
    path: refund.root.url,
    name: refund.root.name,
    handle: refund.root.meta,
    element: <StatisticsLayout />,
    children: [
      {
        // this route only check if user has been initialized refund service or not
        path: refund.root.url,
        index: true,
        element: <CheckPage />,
      },
      {
        // this route show user that start to initialize refund service
        path: refund.init.url,
        name: refund.init.name,
        handle: refund.init.meta,
        element: <InitPage />,
      },
      {
        // this route show contract to user in initializiation steps
        path: refund.contract.url,
        name: refund.contract.name,
        handle: refund.contract.meta,
        element: <ContractPage />,
      },
      {
        path: refund.setting.url,
        name: refund.setting.name,
        handle: refund.setting.meta,
        element: (
          <div>
            <p>this is refund setting</p>
          </div>
        ),
      },
      {
        // this route show success or fail callback to user after charging wallet
        path: refund.receipt.url,
        name: refund.receipt.name,
        handle: refund.receipt.meta,
        element: <ReceiptPage />,
      },
      {
        // this route show wallet details
        path: refund.wallet.url,
        name: refund.wallet.name,
        handle: refund.wallet.meta,
        element: <WalletPage />,
        children: [
          {
            path: refund.walletTransactions.url,
            name: refund.walletTransactions.name,
            handle: refund.walletTransactions.meta,
            element: (
              <div>
                <p>this is wallet transactions</p>
              </div>
            ),
          },
          {
            path: refund.walletDeposit.url,
            name: refund.walletDeposit.name,
            handle: refund.walletDeposit.meta,
            element: (
              <div>
                <p>this is wallet deposit</p>
              </div>
            ),
          },
        ],
      },
    ],
  },
];
export default routes;
